import(/* webpackMode: "eager" */ "/vercel/path0/app/(main)/page.tsx");
